module.exports = __webpack_public_path__ + "img/en.41e06db7.jpg";